// ------------------------------------------------------------------------
// -- JS GLOBAL
// ------------------------------------------------------------------------

// ------------------------------------------
// -- MENU - TOGGLE MOBILE NAV
// ------------------------------------------

function toggleNav() {
    var btn = this
    var nav = document.getElementById(this.getAttribute('aria-controls'));
    if ( btn.getAttribute('aria-expanded') === 'true' ) {
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('nav__toggle--active');
        nav.classList.remove('nav__main--active');
    } else {
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('nav__toggle--active');
        nav.classList.add('nav__main--active');
    }
}
document.getElementById('js__toggleNav').addEventListener('click', toggleNav);


// ------------------------------------------
// -- MENU - TOGGLE SUB MENU
// ------------------------------------------

var subs = document.querySelectorAll('.nav__item--parent');
for (var i = 0; i < subs.length; i++) {
    subs[i].querySelector('.nav__sub').classList.add('nav__sub--hidden');
    subs[i].addEventListener('mouseover', openSubHover);
    subs[i].addEventListener('mouseout', closeSubHover);
    subs[i].querySelector('.nav__link').addEventListener('click', toggleSubClick);
    subs[i].addEventListener("keyup", toggleSubKey);
}

function openSubHover() {
    if (window.innerWidth >= 992) {
        var btn = this.querySelector('.nav__link');
        var sub = this.querySelector('.nav__sub');
        if (btn.getAttribute('aria-expanded') === 'false') {
            btn.setAttribute('aria-expanded', 'true');
            sub.setAttribute('aria-hidden', 'false');
            sub.classList.remove('nav__sub--hidden');
        }
    }
}

function closeSubHover() {
    if (window.innerWidth >= 992) {
        var btn = this.querySelector('.nav__link');
        var sub = this.querySelector('.nav__sub');
        if (btn.getAttribute('aria-expanded') === 'true') {
            btn.setAttribute('aria-expanded', 'false');
            sub.setAttribute('aria-hidden', 'true');
            sub.classList.add('nav__sub--hidden');
        }
    }
}

function toggleSubClick() {
    var btn = this;
    var sub = this.nextElementSibling;
    if (btn.getAttribute('aria-expanded') === 'true') {
        btn.setAttribute('aria-expanded', 'false');
        sub.setAttribute('aria-hidden', 'true');
        sub.classList.add('nav__sub--hidden');
    } else {
        btn.setAttribute('aria-expanded', 'true');
        sub.setAttribute('aria-hidden', 'false');
        sub.classList.remove('nav__sub--hidden');
    }
}

function toggleSubKey(e) {
    var btn = this.querySelector('.nav__link');
    var sub = this.querySelector('.nav__sub');
    if (e.keyCode == "27") {
        if (btn.getAttribute('aria-expanded') === 'true') {
            btn.setAttribute('aria-expanded', 'false');
            sub.setAttribute('aria-hidden', 'true');
            sub.classList.add('nav__sub--hidden');
            btn.focus();
        }
    }
}


// ------------------------------------------
// -- RECHERCHE - TOGGLE MOBILE
// ------------------------------------------

var searchTrigger = document.querySelectorAll('.search__toggle');
for (var i = 0; i < searchTrigger.length; i++) {
    searchTrigger[i].addEventListener('click', toggleSearch);
}

function toggleSearch() {
    var btn = this;
    var btns = document.getElementsByClassName('search__toggle');
    console.log(btns);
    var body = document.body;
    var searchPanel = document.getElementById(this.getAttribute('aria-controls'));
    if ( btn.getAttribute('aria-expanded') === 'true' ) {
        for (var i = 0; i < btns.length; i++) {
            btns[i].setAttribute('aria-expanded', 'false');
        }
        body.classList.remove('search-active');
        searchPanel.classList.remove('search__sidebar--active');
    } else {
        for (var i = 0; i < btns.length; i++) {
            btns[i].setAttribute('aria-expanded', 'true');
        }
        body.classList.add('search-active');
        searchPanel.classList.add('search__sidebar--active');
    }
}


// -----------------------------------------------------
// -- RECHERCHE - SHOW ELEM WITH RADIO OR CHECKBOX
// -----------------------------------------------------

var radiocheckShow = document.querySelectorAll('.js__radiocheck');
for (var i = 0; i < radiocheckShow.length; i++) {
    radiocheckShow[i].addEventListener('click', showRadiocheck);
}
function showRadiocheck() {
    var test = document.getElementById(this.getAttribute('data-target'));
    test.classList.remove('is-hidden')
}





// -----------------------------------------------------
// -- Gestion du bloc destination (continent et pays)
// -----------------------------------------------------

$(".js__moteurAllcountry").click(function(){
    $(this).closest(".js__moteurContinent").find("input").not(".js__moteurAllcountry").prop("checked",false);
});
$(".js__moteurCountry").click(function(){
    $(this).closest(".js__moteurContinent").find(".js__moteurAllcountry").prop("checked",false);
});




// -----------------------------------------------------
// -- Gestion du bloc déjà participé à une retraite
// -----------------------------------------------------

$(".js__participated").change(function(){
    if($(this).val() == "oui") {
        $(".js__participated--toggle").removeAttr("hidden");
        $(".js__participated--toggle").find(".form__radio[value='non']").prop("checked",false);
    }else{
        $(".js__participated--toggle").attr("hidden","");
        $(".js__participated--toggle").find(".form__radio[value='non']").prop("checked",true);
    }
});



// -----------------------------------------------------
// -- Gestion du choix autre
// -----------------------------------------------------
$(".js__other").on("change", function() {
    var target = $("#" + $(this).data("other"));
    var isOther = false;

    if ($(this).is("select")) {
        isOther = $(this).val() === "autre";
    } else if ($(this).is(":checkbox")) {
        isOther = $(this).is(":checked");
    }

    target.prop("hidden", !isOther);

    if (!isOther) {
        target.find("input, textarea, select").val("");
    }
});

// -----------------------------------------------------
// -- Gestion du choix covoiture
// -----------------------------------------------------
$(".js__covoit").on("change", function() {
    var target = $("#" + $(this).data("covoit"));
    var isOther = false;

    if ($(this).is("select")) {
        isOther = $(this).val() === "covoit";
    } else if ($(this).is(":checkbox")) {
        isOther = $(this).is(":checked");
    }

    target.prop("hidden", !isOther);

    if (!isOther) {
        target.find("input, textarea, select").val("");
    }
});